import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Icon, Menu, MenuItem, Popover, Button, Position, Intent } from '@blueprintjs/core';
import apiAdonis from '../../../Services/adonis';
import { NotificacaoInterna } from '../../../Services/Notification';

import { IconeConfiguracoes, LogoOnePlus, IconeNotificacao, LogomarcaGAVResortsOriginal as LogomarcaGAVResorts, LogomarcaHarmoniaUrbanismoOriginal as LogomarcaHarmoniaUrbanismo, LogomarcaSilvaBrancoOriginal as LogomarcaSilvaBranco, LogomarcaDigitalDevOriginal as LogomarcaDigitalDev, LogomarcaPattroOriginal as LogomarcaPattro, LogomarcaCasaETerra as LogomarcaCasaETerra, LogomarcaEspaco as LogomarcaEspaco, IconeUsuario } from '../../../Assets';
import { SignIn as ContextSignIn } from '../../../Context';
import * as Component from './style';
import './style.css'


const View: React.FC = () => {
    /* #region  Variáveis  */
    const History = useHistory();
    const [getExibirSideBar, setExibirSideBar] = useState<boolean>(false);
    /* #endregion */

    /* #region  Funções  */
    useEffect(() => {
        async function componentDidMount() { }
        componentDidMount();
    }, []);

    return (
        <Component.Container>
            <Component.HeaderContent>
                <div style={{ display: "flex", alignItems: "center", width: "10%", height: "100%", backgroundColor: "transparent" }}>
                    <img style={{ width: "75px", height: "15px", pointerEvents: "none" }} src={LogoOnePlus} />
                </div>
                <div className="element" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "50px", color: "white", height: "100%", marginLeft: "0" }}>
                    <Popover content={
                        <Menu>
                            {/* <MenuItem icon={"user"} color="white" text={localStorage.getItem("username")} /> */}
                            <MenuItem icon="cog" text="Configuracoes...">
                                {ContextSignIn.getContext().UltimoGrupoDeEmpresasAcessado == 4 && <MenuItem icon="comparison" text="Categorias de reserva" href="/CategoriasReserva" />}
                                {ContextSignIn.getContext().UltimoGrupoDeEmpresasAcessado == 4 && <MenuItem icon="comparison" text="De-Para CNAEs (NFSe)" href="/DeParaCNAEs" />}
                                {true && <MenuItem icon="comparison" text="De-Para Empresas" href="/ConfigDePara" />}
                            </MenuItem>
                            <MenuItem onClick={() => {
                                History.replace("/Menu");
                                window.location.reload();
                            }} icon={"layout-grid"} text={"Menu"} />
                            <MenuItem onClick={() => {
                                apiAdonis.get("/empPerms", {
                                    params: { userId: JSON.parse(localStorage.getItem("user") ?? "{}").id }
                                }).then(res => {
                                    const emp_permissions: { cd_emp: number, userId: number, is_admin: boolean }[] | [] = res.data;
                                    if (emp_permissions.find(emp_perm => emp_perm.is_admin)) {
                                        History.replace("/users");
                                        window.location.reload();
                                    }
                                    else {
                                        NotificacaoInterna.ExibirNotificacao("Acesso Negado", "Você não possui permissão para acessar essa página!", NotificacaoInterna.TipoDeNotificacao.Informacao);
                                    }
                                })
                            }} icon={"user"} text={"Usuários"} />
                            <MenuItem onClick={() => {
                                apiAdonis.post('/logout', {}, {
                                    headers: {
                                        Authorization: `Bearer ${localStorage.getItem("token")}`
                                    }
                                }).then(async () => {
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("username");
                                    History.replace("/");
                                    window.location.reload();
                                    getExibirSideBar == true ? await setExibirSideBar(false) : await setExibirSideBar(true);
                                });
                            }} icon={"log-out"} text={"Sair"} />
                        </Menu>
                    } position={Position.BOTTOM_RIGHT}>
                        <div style={{ cursor: "pointer", width: "50px", minWidth: "50px", height: "40px", minHeight: "100%", borderRadius: "0%", backgroundColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <img style={{ width: "25px", height: "25px", borderRadius: "50%", marginLeft: "0px" }} alt="" src={IconeUsuario} />
                        </div>
                    </Popover>
                </div>
            </Component.HeaderContent>
        </Component.Container>
    );
    /* #endregion */
};


export default View;